<div class="panel rs-bg-grey1 clearfix" *ngIf="eMarketingOption">
  <h3 class="rs-tit6">{{ eMarketingOption.name }}</h3>
  <div class="panel clearfix">
    <div class="rs-flex-row rs-flex-dir-col-small-only">
      <div class="rs-flex-column">
        <h4 class="rs-tit6">{{ 'digitalis.eMarketing.title' | translate }}</h4>
        <p>{{ eMarketingOption.description }}</p>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <div class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only">
          <div class="rs-flex-column">
            <p class="small-only-text-center">
              <px-currency-amount
                *ngIf="eMarketingOption?.price?.priceVat"
                [amount]="eMarketingOption.price.priceVat.toString()"
                [amountClass]="'rs-price-sm'"
              ></px-currency-amount>
            </p>
          </div>
          <div class="rs-flex-column rs-flex-shrink">
            <mprd-order-button
              [(option)]="eMarketingOption"
              [(orderDisabled)]="orderButtonsDisabled"
              [selectedProduct]="selectedProduct"
              (resultEmit)="onResult($event)"
            ></mprd-order-button>
          </div>
        </div>
      </div>
      <px-alert [alertKey]="'eMarketingAlert'"></px-alert>
    </div>
    <div aria-live="polite"></div>
  </div>
</div>
